module.exports = __webpack_public_path__ + "img/logo_menu.bc566316.png";